import React from 'react';
import ReactDOM, {hydrate, render} from 'react-dom';
import Store from "./context/dataStore";
import RoleStore from "./context/rolesStore";
import AppWrapper from './containers/Appwraper/AppWrapper';
import { createRoot } from 'react-dom/client';

import './assets/styles/app.scss';


if (process.env.ENV !== 'prod') {
  const axe = require('react-axe');
  axe(React, ReactDOM, 1000);
}

/**
 * element in HTML document for React SPA
 * @type {ReactElement}
 */
const rootElement = document.getElementById('app');

/**
 * React SPA
 * @type {ReactElement}
 */
const rootComponent = (
  <Store>
    <RoleStore>
      <AppWrapper />
    </RoleStore>
  </Store>
);



const root = createRoot(rootElement);
if (rootElement.hasChildNodes()) {
  root.hydrate(rootComponent);
} else {
  root.render(rootComponent);
}
